import React from 'react';
import {MenuItem, Select} from '@material-ui/core';
import useMrssDefaults from '@pluto/mrss-defaults-hook';

export const mapOptions = (value: string) => (
    <MenuItem
        key={value}
        value={value}
    >
        {value}
    </MenuItem>
);

export const SourceRegionContainer = (props: any) => {
    const {mrssDefaults, value, onChange, setMrssDefaults} = props;
    
    useMrssDefaults({
        setMrssDefaults,
        mrssDefaults,
    });
    
    const territories = mrssDefaults?.data?.territories || [];
    const options = territories.map(mapOptions);
    
    return (
        <Select
            className="qc-metadata__editable-item"
            value={value}
            onChange={onChange}
        >
            {options}
        </Select>
    );
};
